export default {
      id: "ar_travaux-usage",
      viewBox: "0 0 90 75",
      url: "../dist/images/" + "sprite.svg#ar_travaux-usage",
      toString: function () {
        return this.url;
      }
    }